import * as PropTypes from 'prop-types';
import * as React from 'react';
import ShippingRegionSelector from './shipping_region_selector';
import * as classNames from 'classnames';
import PriceFieldWithCurrency from '../shared/price_field_with_currency';

class NewShippingRate extends React.Component {
  constructor(props) {
    super(props);

    this.setShippingRegion = this.setShippingRegion.bind(this);
    this.setPrice = this.setPrice.bind(this);
    this.setExpeditedPrice = this.setExpeditedPrice.bind(this);
    this.setIncrementalPrice = this.setIncrementalPrice.bind(this);
    this.setFreeShippingPrice = this.setFreeShippingPrice.bind(this);
  }

  setShippingRegion(shippingRegion) {
    this.props.onNewShippingRateChange({
      regionType: shippingRegion.region_type,
      regionCode: shippingRegion.code,
      regionName: shippingRegion.name,
    });
  }

  setPrice(e) {
    this.props.onNewShippingRateChange({
      rate: {
        amount: e.target.value,
        currency: this.props.newShippingRate.rate.currency,
      },
    });
  }

  setExpeditedPrice(e) {
    this.props.onNewShippingRateChange({
      expeditedRate: {
        amount: e.target.value,
        currency: this.props.newShippingRate.rate.currency,
      },
    });
  }

  setIncrementalPrice(e) {
    this.props.onNewShippingRateChange({
      incrementalRate: {
        amount: e.target.value,
        currency: this.props.newShippingRate.rate.currency,
      },
    });
  }

  setFreeShippingPrice(e) {
    this.props.onNewShippingRateChange({
      freeShippingThreshold: {
        amount: e.target.value,
        currency: this.props.newShippingRate.rate.currency,
      },
    });
  }

  renderAddButton() {
    const buttonClasses = classNames(
      'btn', 'btn-small', 'btn-blue',
      {
        'btn-disabled': !this.props.newShippingRate.isValid,
      },
    );

    return (
      <button
        className={buttonClasses}
        onClick={this.props.onAddShippingRate}
      >
        {I18n.t('shippingRates.addRate')}
      </button>
    );
  }

  renderBaseRateField() {
    return (
      <div className="shipping-rate-label-pair" data-new-shipping-rate-price>
        <label>
          {I18n.t('shippingRates.rateFields.standardRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.newShippingRate.rate.currency}
          value={this.props.newShippingRate.rate.amount}
          onChange={this.setPrice}
        />
      </div>
    );
  }

  renderIncrementalRateField() {
    if (!this.props.showIncrementalFields) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair" data-new-shipping-rate-incremental-price>
        <label>
          {I18n.t('shippingRates.rateFields.incrementalRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.newShippingRate.incrementalRate.currency}
          value={this.props.newShippingRate.incrementalRate.amount}
          onChange={this.setIncrementalPrice}
        />
      </div>
    );
  }

  renderFreeShippingThresholdField() {
    if (!this.props.showFreeShippingThresholdFields) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair" data-new-shipping-rate-free-shipping-threshold>
        <label>
          {I18n.t('shippingRates.rateFields.freeShippingThreshold')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.newShippingRate.freeShippingThreshold.currency}
          value={this.props.newShippingRate.freeShippingThreshold.amount}
          onChange={this.setFreeShippingPrice}
        />
      </div>
    );
  }

  render() {
    return (
      <tr>
        <td className="shipping-rate-location has-select add-shipping-region-select valign-bottom">
          <div className="styled-dropdown mb-0">
            <ShippingRegionSelector
              shippingRegions={this.props.shippingRegions}
              shippingRates={this.props.shippingRates}
              onChange={this.setShippingRegion}
              newShippingRate={this.props.newShippingRate}
            />
          </div>
        </td>
        <td className="shipping-rate-cost valign-bottom">
          {this.renderBaseRateField()}
          {this.renderIncrementalRateField()}
          {this.renderFreeShippingThresholdField()}
        </td>
        <td className="shipping-rate-action align-center valign-bottom">
          {this.renderAddButton()}
        </td>
      </tr>
    );
  }
}

NewShippingRate.propTypes = {
  shippingRegions: PropTypes.array.isRequired,
  shippingRates: PropTypes.array.isRequired,
  showExpeditedFields: PropTypes.bool.isRequired,
  showIncrementalFields: PropTypes.bool.isRequired,
  showFreeShippingThresholdFields: PropTypes.bool.isRequired,
  fieldsPrefix: PropTypes.string.isRequired,
  onNewShippingRateChange: PropTypes.func.isRequired,
  onAddShippingRate: PropTypes.func.isRequired,
  newShippingRate: PropTypes.object.isRequired,
  canAddNewShippingRate: PropTypes.bool,
};

export default NewShippingRate;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates/new_shipping_rate.jsx